import axios from 'axios';

const updateCompliance = params => {
  return axios.put(`compliance`, params);
};

export { updateCompliance };
